import { render, staticRenderFns } from "./regDataInsertSlot.vue?vue&type=template&id=cfc129fc&scoped=true&"
import script from "./regDataInsertSlot.vue?vue&type=script&lang=js&"
export * from "./regDataInsertSlot.vue?vue&type=script&lang=js&"
import style0 from "./regDataInsertSlot.vue?vue&type=style&index=0&id=cfc129fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc129fc",
  null
  
)

export default component.exports